export default __webpack_public_path__ + "static/media/bonafont.2e533210.svg";